export const Media_Assets = {
  Logo: "/sovereign-core/logo.png",
  Contact_Desk: "/sovereign-core/contact-desk.jpg",
} as const;
